import request from '@/utils/request'
import exportRequest from '@/utils/export'

// 统计总表数据
export function getStaticList(params) {
  return request({
    url: 'statistics/attendees',
    method: 'post',
    data: params
  })
}
// 参会人详情数据
export function getDetails(params) {
  return request({
    url: 'statistics/attendeesDetail',
    method: 'post',
    data: params
  })
}
// 部门统计数据
export function departmentCount(params) {
  return request({
    url: 'statistics/morningDepartment',
    method: 'post',
    data: params
  })
}
// 数据穿透
export function departmentDetails(params) {
  return request({
    url: 'statistics/morningDepartmentDetail',
    method: 'post',
    data: params
  })
}
// 导出未填写任务人员
export function downloadAllPerson(params) {
  return request({
    url: '',
    method: 'post',
    data: params
  })
}
// 导出异常清单
export function downloadException(params) {
  return exportRequest({
    url: 'statistics/morningDepartmentExecl',
    method: 'post',
    data: params
  })
}

// 个人议事规则情况
export function personRolePage(params) {
  return request({
    url: '/statistics/personRole',
    method: 'post',
    data: params
  })
}
// bumen议事规则情况
export function departmentRole(params) {
  return request({
    url: '/statistics/departmentRole',
    method: 'post',
    data: params
  })
}
